import { useDebounce } from "../../../lib/hooks/debounce";
import { keycloak } from "../../../lib/keycloak";
import { setOptionsActive } from "../../../lib/preferences/slice";
import { useAppDispatch, useAppSelector } from "../../../lib/redux/hooks";
import { groupBy } from "../../../lib/utils";
import { MoreHorizontalIcon } from "../../../ui/icons/moreHorizontal";
import { SearchIcon } from "../../../ui/icons/search";
import Button from "../../../ui/molecules/button";
import Input from "../../../ui/molecules/input";
import { SelectCustom } from "../../../ui/molecules/select";
import { UserRole } from "../../users/dto";
import { SelectUser } from "../../users/select/userSelect";
import { FindAllTargetListsFilters, TargetListStatusEnum } from "../dto";

interface Props {
  filters: FindAllTargetListsFilters
  setFilters: (filters: Partial<FindAllTargetListsFilters>) => void
}

export function TargetListsFilters({ filters, setFilters }: Props) {
  const atecosState = useAppSelector((state) => state.atecos);
  const preferencesState = useAppSelector((state) => state.preferences);
  const dispatch = useAppDispatch();

  const debounce = useDebounce(
    (value) => setFilters({ name: value }),
    1000
  );

  return (
    <div
      className="px-4"
      style={{
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        gap: "8px",
        width: "100%",
        height: "64px",
        flexShrink: 0
      }}
    >
      <Input
        startIcon={<SearchIcon color={""} size={0} />}
        placeholder="Cerca nelle liste"
        onChangeText={(value) => debounce(value)}
        defaultValue={filters.name}
      />
      {!(keycloak.hasRealmRole('customer') || keycloak.hasRealmRole('collaborator')) &&
        <SelectUser
          isMulti={true}
          id="select-teamleaders-target-filters"
          role={UserRole.team_leader}
          value={filters.teamLeader}
          onChange={(value) => setFilters({ teamLeader: value })}
          placeholder={"Team Leaders"}
          keepOverflow
          isClearable
        />
      }
      {!(keycloak.hasRealmRole('customer') || keycloak.hasRealmRole('collaborator')) &&
        <SelectUser
          isMulti={true}
          id="select-commercials-target-filters"
          role={UserRole.commercial}
          value={filters.commercial}
          onChange={(value) => setFilters({ commercial: value })}
          placeholder={"Commerciali"}
          keepOverflow
          isClearable
        />
      }
      <SelectCustom
        isClearable
        placeholder="Settore"
        options={groupBy(atecosState.findAllAtecosResponse, "sector").map(
          (sector) => ({ label: sector.key, value: sector.key })
        )}
        onChange={(value) => setFilters({ sector: value ? Array.isArray(value) ? value : [value] : [] })}
        defaultValue={filters.sector}
      />
      <SelectCustom
        isClearable
        placeholder="Categoria"
        options={groupBy(atecosState.findAllAtecosResponse, "category").map(
          (sector) => ({ label: sector.key, value: sector.key })
        )}
        onChange={(value) => setFilters({ category: value ? Array.isArray(value) ? value : [value] : [] })}
        defaultValue={filters.category}
      />
      <SelectCustom
        isClearable
        placeholder="Stato"
        options={[
          { label: "Da iniziare", value: TargetListStatusEnum.TOSTART },
          { label: "In corso", value: TargetListStatusEnum.INPROGRESS },
          { label: "Sospeso", value: TargetListStatusEnum.SUSPENDED },
          { label: "Concluso", value: TargetListStatusEnum.CONCLUDED },
        ]}
        onChange={(value) => setFilters({ state: value ? Array.isArray(value) ? value as TargetListStatusEnum[] : [value as TargetListStatusEnum] : [] })}
        defaultValue={filters.state}
      />
      <div>
        <Button
          size={"sm"}
          iconPosition={"only"}
          variant={preferencesState.optionsActive ? "outline" : "ghost"}
          color={preferencesState.optionsActive ? "blue" : "gray"}
          onClick={() => dispatch(setOptionsActive(!preferencesState.optionsActive))}
          icon={<MoreHorizontalIcon color={""} size={0} />}
        />
      </div>
    </div>
  );
}
